module.exports = __webpack_public_path__ + "img/byakuren hijiri.37aec508.png";